import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Copy, GreenCheck, Loading, RedError } from "src/components";
import { _ } from "src/services";
import { Packages, PackagesAction } from "src/store";
import { NotFound } from "./not.found";

export const PaymentResult: React.FC = () => {

    //#region dependencies

    const { orderId }: any = useParams();
    const dispatch = useDispatch();
    const packages: Packages = useSelector((state: any) => state.PackagesState);

    //#endregion

    //#region effects

    useEffect(() => {
        dispatch(PackagesAction.requestOrderInfo(orderId));

        return () => {
            dispatch(PackagesAction.clear());
        };

    }, [dispatch, orderId]);

    //#endregion

    //#region properties

    const { orderStatus, programId, packageTitle, subscriptionEndedOn, partner, durationType, gift } = packages.order || {};

    const title = orderStatus ? _("successfulPurchase") : _("unsuccessfulPurchase");
    const description = orderStatus ? _("successfulPurchaseDescription") : _("unsuccessfulPurchaseDescription");
    const Icon = orderStatus ? GreenCheck : RedError;

    //#endregion

    //#region methods

    const onCopy = () => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText("" + gift?.code);
            toast.success(_("giftCodeCopied"));
        }
        else {
            toast.error(_("giftCodeNotCopied"));
        }
    };

    //#endregion

    if (packages.loading || !packages.order) {
        return (
            <div className="container program-page app-theme2 p-0 p-md-2 py-4 my-4">
                <div className="py-4 my-4">
                    <Loading />
                </div>
            </div>
        );
    }

    if (packages.order.id < 0) return (<NotFound />);

    return (
        <div className="container program-page app-theme2 p-0 p-md-2 py-4">
            <div className="payment-bill-info d-flex flex-column justify-content-center align-items-center my-4 py-4">
                <Icon size={64} />
                <h1 className="payment-box__title mt-4">{title}</h1>
                <h2 className="payment-box__description mt-2">{description}</h2>
                <h3 className="payment-box__xtitle text-white mt-4">{_("packageType")}:</h3>
                <h3 className="payment-box__xtitle text-white mt-2">
                    <span>{durationType} {packageTitle}</span>
                    {
                        partner && partner.partnerName &&
                        <>
                            <span className="mx-2">+</span>
                            <span style={{ color: partner.colorCode }}>{partner.productName} {partner.partnerName}</span>
                        </>
                    }
                </h3>
                {
                    orderStatus &&
                    <>
                        <span className="payment-box__xxtitle mb-4">{_("packagedActivated").replaceAll("{date}", subscriptionEndedOn || "")}</span>
                        {
                            gift && gift.has &&
                            <>
                                <h3 className="payment-box__xtitle text-white mt-4">{gift?.title}</h3>
                                <span className="payment-box__xxtitle">{gift?.message}</span>
                                <div className="payment-package-info d-flex align-items-center w-100 py-3 px-3 mt-2">
                                    {
                                        !!gift?.code &&
                                        <>
                                            <span className="flex-1" style={partner ? { color: partner.colorCode } : { color: "rgb(12, 155, 207)" }}>{gift?.code}</span>
                                            <button className="copy-btn" onClick={onCopy}>
                                                <Copy size={18} />
                                                <span className="mr-1">{_("copy")}</span>
                                            </button>
                                        </>
                                    }
                                    {
                                        !!gift?.link &&
                                        <a className="flex-1 align-items-center justify-content-center"
                                            href={gift?.link}
                                            target="_blank" rel="noreferrer noopner"
                                            style={partner ? { color: partner.colorCode } : { color: "rgb(12, 155, 207)" }}>{gift?.link}</a>
                                    }
                                </div>
                            </>
                        }
                    </>
                }
                <Link className="btn btn-submit btn-payment order-1 mt-4 px-4"
                    to={programId ? `/program/${programId}` : '/'} style={{ width: "auto" }}>
                    <div>
                        <span>{programId ? _("returnToProgram") : _("returnToHome")}</span>
                    </div>
                </Link>
            </div>
        </div>
    );
};